var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRoundSortHorizontal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 2.5999C5.913 2.5999 2.5999 5.913 2.5999 9.9999C2.5999 14.0868 5.913 17.3999 9.9999 17.3999C14.0868 17.3999 17.3999 14.0868 17.3999 9.9999C17.3999 5.913 14.0868 2.5999 9.9999 2.5999ZM1.3999 9.9999C1.3999 5.25025 5.25025 1.3999 9.9999 1.3999C14.7496 1.3999 18.5999 5.25025 18.5999 9.9999C18.5999 14.7496 14.7496 18.5999 9.9999 18.5999C5.25025 18.5999 1.3999 14.7496 1.3999 9.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44387 5.5963C9.66677 5.84149 9.6487 6.22096 9.40351 6.44387L8.35187 7.3999H13.1999C13.5313 7.3999 13.7999 7.66853 13.7999 7.9999C13.7999 8.33127 13.5313 8.5999 13.1999 8.5999H8.35187L9.40351 9.55594C9.6487 9.77884 9.66677 10.1583 9.44387 10.4035C9.22096 10.6487 8.84149 10.6668 8.5963 10.4439L6.3963 8.44387C6.27121 8.33015 6.1999 8.16895 6.1999 7.9999C6.1999 7.83086 6.27121 7.66965 6.3963 7.55594L8.5963 5.55594C8.84149 5.33303 9.22096 5.3511 9.44387 5.5963Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5559 9.5963C10.333 9.84149 10.3511 10.221 10.5963 10.4439L11.6479 11.3999H6.7999C6.46853 11.3999 6.1999 11.6685 6.1999 11.9999C6.1999 12.3313 6.46853 12.5999 6.7999 12.5999H11.6479L10.5963 13.5559C10.3511 13.7788 10.333 14.1583 10.5559 14.4035C10.7788 14.6487 11.1583 14.6668 11.4035 14.4439L13.6035 12.4439C13.7286 12.3302 13.7999 12.1689 13.7999 11.9999C13.7999 11.8309 13.7286 11.6697 13.6035 11.5559L11.4035 9.55594C11.1583 9.33303 10.7788 9.3511 10.5559 9.5963Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundSortHorizontal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RoundSortHorizontal.56d447b3.svg";
export { ForwardRef as ReactComponent };